module.exports = __webpack_public_path__ + "img/myprofile-savebtn.d504424e.svg";